import React from 'react';
import { Container, Image, Row, Col } from 'react-bootstrap';

//Images
import spaceCastleLander from '../img/about/SpaceCastleLander.png';
import hamJamHighFive from '../img/about/HamJamFive.png';
import gerepad from '../img/about/gerepad.png';
import balloonKaboomIcon from '../img/about/balloonkaboom.png';
import '../css/About.css';

function About() {
    return <Container className="page-container mt-3">
        <Row className="banner-container">
            <Col className="px-0">
                <Image src={spaceCastleLander} className="banner-img" />
            </Col>
        </Row>
        <Row className="mt-3">
            <Col>
                <p>Greetings from Space Castle Games. My name is Jason and I’m a hobbyist game developer.
                <br />What does that mean?
                    <ol>
                        <li>I do this on my spare time. 🙂</li>
                        <li>Projects may take much longer than they should. 😦</li>
                        <li>I don’t have to worry about limited funding. 🙂</li>
                    </ol>
                </p>

            </Col>
            <Col><Image src={balloonKaboomIcon} />
            </Col>
        </Row>
        <Row><Col><p className="caption mt-5"><a target="_blank" href="https://spacecastle.itch.io/">Itch.io</a> | <a target="_blank" href="https://play.google.com/store/apps/dev?id=5052605220258564120">Google Play</a> | <a target="_blank" href="https://www.youtube.com/channel/UCyao2g_1E7VbFRQVZbAXiYg">Youtube</a> | <a target="_blank" href="https://www.twitch.tv/spacecastlegames">Twitch</a> | <a target="_blank" href="mailto:spacecastlegames@gmail.com">Email</a></p></Col></Row>
        <Row>
            <Col>
                <p>I also want to give a shout out to Brandon for all his artistic help! Thanks buddy!</p>
            </Col>
        </Row>
        <Row>
            <Col>
                <Image src={hamJamHighFive} />
            </Col>
            <Col>
                <Image src={gerepad} />
            </Col>
        </Row>
    </Container>


}
export default About;